import { ThemeManager } from "../../theme";

import { isObject, isString } from "@visactor/vutils";

export function getThemeObject(theme) {
    return isString(theme) ? ThemeManager.themeExist(theme) ? ThemeManager.getTheme(theme) : {} : isObject(theme) ? theme : {};
}
//# sourceMappingURL=common.js.map
